<template>
    <DataTable
        title="Payout Events"
        :headers="PayoutEvent.headers()"
        :model-class="PayoutEvent"
        :items="page.props.data"
        :crud-config="{
            createDialogBtnText: 'Create Payout Event',
            updateDialogBtnText: 'Update Payout Event',
            deleteDialogBtnText: 'Delete Payout Event',
            showCreateAction: true,
            showUpdateAction: true,
            showDeleteAction: true,
            showViewAction: true,
        }"
        :config="useConfig().bundle"
    >
        <template #create-action-dialog="{ item }">
            <CreateBundleDialog :item />
        </template>
        <template #update-action-dialog="{ item }">
            <UpdateBundleDialog :item />
        </template>
        <template #delete-action-dialog="{ item }">
            <DeleteBundleDialog :item />
        </template>
        <template #custom-action="{ item }">
            <ShowButton :to="usePayoutEventRepository().query.show(item.id).endpoint" />
        </template>
    </DataTable>
</template>

<script setup lang="ts">
import { PayoutEvent } from '../../models/PayoutEvent';
import { useConfig } from '@shared/composables/useConfig';
import { usePayoutEventRepository } from '../../repositories/usePayoutEventRepository';

const page = PayoutEvent.routes().index.page;
</script>
